import { render, staticRenderFns } from "./Guarantor.vue?vue&type=template&id=563d64e1&"
import script from "./Guarantor.vue?vue&type=script&lang=js&"
export * from "./Guarantor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports